<template>
  <div class="c-serviceSearchParentCategoryContent">
    <!-- 人気のカテゴリ -->
    <PopularSubCategories
      class="c-serviceSearchParentCategoryContent_popularCategories"
      :sub-categories="contents.popularCategoriesList"
      :category-id="categoryId"
      link-ref="category_popular_subcategories"
    />
    <!-- サービスランキング -->
    <SearchServiceCarousel
      v-for="serviceRanking in contents.serviceRankingsList"
      :key="serviceRanking.title"
      class="c-serviceSearchParentCategoryContent_services"
      :services="serviceRanking.servicesList"
      :title="serviceRanking.title"
      :show-more-url="addQueryToUrlIfBusinessPreview(serviceRanking.url)"
      :sub-title="getRankingPeriodText(serviceRanking.tallyingPeriodFrom, serviceRanking.tallyingPeriodTo)"
      link-ref="category_ranking"
      is-ranking
    />

    <!-- おすすめのサービス -->
    <SearchServiceCarousel
      class="c-serviceSearchParentCategoryContent_services"
      :services="contents.recommendServicesList"
      title="おすすめのサービス"
      :show-more-url="addQueryToUrlIfBusinessPreview(`${showMoreServicePath}&sort_by=recommend`)"
      link-ref="category_recommend"
    />
    <!-- ココナラのメリット -->
    <CoconalaMerit
      v-if="isBeginner"
      class="c-serviceSearchParentCategoryContent_merit"
    />
    <!-- 今すぐ相談できる電話占い -->
    <SearchServiceCarousel
      v-if="isFortuneTelling()"
      class="c-serviceSearchParentCategoryContent_services"
      :services="contents.providerPhoneWaitServicesList"
      title="今すぐ相談できる電話占い"
      :show-more-url="addQueryToUrlIfBusinessPreview('/categories/3?service_kind=1&provider_statuses%5B%5D=phone_wait')"
      link-ref="category_phone_wait"
    />
    <!-- お気に入りが多いサービス -->
    <SearchServiceCarousel
      class="c-serviceSearchParentCategoryContent_services"
      :services="contents.manyFavoritedServicesList"
      title="お気に入りが多いサービス"
      :show-more-url="addQueryToUrlIfBusinessPreview(`${showMoreServicePath}&sort_by=fav`)"
      link-ref="category_favorites"
    />
    <!-- 新着サービス -->
    <SearchServiceCarousel
      class="c-serviceSearchParentCategoryContent_services"
      :services="contents.newlyArrivedServicesList"
      title="新着サービス"
      :show-more-url="addQueryToUrlIfBusinessPreview(`${showMoreServicePath}&sort_by=new`)"
      :display-rating="false"
      link-ref="category_newservices"
    />
    <!-- おすすめユーザー -->
    <SearchServiceUsersCarousel
      class="c-serviceSearchParentCategoryContent_usersRanking"
      :users="contents.providerRankingList"
      title="おすすめユーザー"
      :showMoreUrl="addQueryToUrlIfBusinessPreview(getUsersRankingShowMoreUrl())"
      link-ref="category_recommended_user"
    />
  </div>
</template>

<script>
import CoconalaMerit from './components/CoconalaMerit'
import PopularSubCategories from './components/PopularSubCategories'
import RecommendedSearchTags from './components/RecommendedSearchTags'
import SearchServiceCarousel from './components/SearchServiceCarousel'
import SearchServiceUsersCarousel from './components/SearchServiceUsersCarousel'

import businessMixin from '~/mixins/pages/business-mixin'

import { mapState } from 'vuex'

/** 占いカテゴリID */
const FORTUNE_TELLING_CATEGORY_ID = 3

/** @type {import('vue').ComponentOptions} */
const serviceSearchParentCategoryContent = {
  name: 'ServiceSearchParentCategoryContent',
  components: {
    CoconalaMerit,
    PopularSubCategories,
    RecommendedSearchTags,
    SearchServiceCarousel,
    SearchServiceUsersCarousel
  },
  mixins: [businessMixin],
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    /**
     * 大カテTOPコンテンツ
     * TODO ダミーデータからこちらに差し替え
     */
    contents: {
      type: Object,
      default: null
    },
    isBeginner: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('master', ['masterCategories']),
    showMoreServicePath() {
      // 「もっと見る」のリンク先は大カテTOPにならないようにする
      return `/categories/${this.categoryId}?category_top=false`
    }
  },
  methods: {
    isFortuneTelling() {
      return this.categoryId === FORTUNE_TELLING_CATEGORY_ID
    },
    /**
     * ランキング集計期間テキスト取得
     * @param {number} from 開始日時
     * @param {number} to 終了日時
     */
    getRankingPeriodText(from, to) {
      const fromText = this.$util.dayjs.unix(from).format('M/D')
      const toText = this.$util.dayjs.unix(to).format('M/D')
      return `期間：${fromText}〜${toText}`
    },
    /**
     * ユーザーランキングの"もっと見る"リンク
     */
    getUsersRankingShowMoreUrl() {
      const category = this.masterCategories.find(x => x.id === this.categoryId)
      const jobIdsQuery = category?.jobIdsList?.map(x => `jobIds[]=${x}`) || []
      const queryString = jobIdsQuery.length > 0 ? `?${jobIdsQuery.join('&')}` : ''
      return `/users/search${queryString}`
    }
  }
}
export default serviceSearchParentCategoryContent
</script>

<style lang="scss" scoped>
.c-serviceSearchParentCategoryContent {
  &_services {
    margin-top: 40px;
  }
  &_tags {
    margin-top: 40px;
  }
  &_merit {
    margin-top: 40px;
  }
  &_usersRanking {
    margin-top: 40px;
  }
  &_newUsers {
    margin-top: 40px;
  }
  &_fortuneTellers {
    margin-top: 40px;
  }
}
@media (max-width: breakpoint(Search, M)) {
  .c-serviceSearchParentCategoryContent {
    &_merit {
      margin-top: 30px;
      padding: 24px 12px;
      background-color: $color-white;
    }
  }
}
</style>
